import React, { useEffect, useMemo, useState } from "react";
import { DownloadFile } from "../utility/functions/firebase";
import { useDispatch, useSelector } from "react-redux";
import {
  selectDefultProfileSetting,
  selectPrefix,
  selectWidth,
} from "../utility/Redux/profile";
import { toProperCase } from "../utility/component/format";
import { FormatNumber2 } from "../utility/functions/formatNumber";
import HandleIndexedDB from "../Test/handleIndexDb";
import "./animat.css";
import { fastMovingMovieItem, openItemTitle } from "../utility/constant";
import { getCurrency } from "./common";
import { itemClick } from "./function";
import { selectToken } from "../utility/Redux/security";

const ItemBox = ({
  box,
  onClick,
  index,
  imgCard,
  mobileWidth,
  isAddButtonType,
  billCartList,
  setBillCartList,
  billingDetails,
  customerDetails,
  setAlertTwoButtonModal,
  setRemarksStatus,
}) => {
  const prefix = useSelector(selectPrefix);
  const icode = box.ICODE;
  const dispatch = useDispatch();
  const path = `retailx/items/${prefix.replace(/_.+_/, "_") + icode}`;
  const [img, setImg] = useState("");
  const width = useSelector(selectWidth);
  const [refreshButton, setRefreshButton] = useState(false);
  const isinBillCart = useMemo(() => {
    if (isAddButtonType) {
      const data = billCartList.filter((b) => b.ICODE === box.ICODE);

      return data;
    } else {
      return [];
    }
  }, [billCartList]);
  const fireToken = localStorage.getItem("fire");

  useEffect(() => {
    if (box.IMAGE_1) {
      setImg(box.IMAGE_1);
      return;
    }
    if (!fireToken) {
      if (width > 600) {
        const isImgAvailval = imgCard.filter((o) => o.ICODE === box.ICODE);
        if (!img && navigator.onLine && !isImgAvailval[0]) {
          DownloadFile(path)
            .then((e) => {
              if (!e.includes("FirebaseError")) {
                const urlParams = new URLSearchParams(new URL(e).search);
                const token = urlParams.get("token");
                localStorage.setItem("fire", token);

                setImg(e);
              } else {
                setImg("");
              }
            })
            .catch((e) => {
              setImg("");
            });
        } else {
          if (imgCard[0]) {
            const i = imgCard.filter((o) => o.ICODE === box.ICODE);
            if (i[0]) {
              setImg(i[0]?.image);
            }
          }
        }
      }
    } else {
      const path = `https://firebasestorage.googleapis.com/v0/b/retailx-126e1.appspot.com/o/retailx%2Fitems%2F${
        prefix.replace(/_.+_/, "_") + box.ICODE
      }?alt=media&token=${fireToken}`;
      setImg(path);
    }
  }, [box]);
  const token = useSelector(selectToken);
  const profileSetting = useSelector(selectDefultProfileSetting);

  return (
    <button
      className={`
        w-full  rounded-lg transition-all  duration-200 
        flex items-start 
        ${
          !isAddButtonType &&
          (box.ITEMNAME === openItemTitle
            ? "bg-[#dae74a]  p-1"
            : box.SECTION_NAME === fastMovingMovieItem
            ? "bg-[#f7b03e]  p-1"
            : "bg-[#f5eb82]  p-1  hover:shadow-lg")
        }
      `}
    >
      {!isAddButtonType && (
        <div
          onClick={() => onClick(box)}
          className=" w-full  rounded-lg transition-all  duration-200 
        flex items-start "
        >
          {img && (
            <div
              className={`w-16 h-16 rounded-lg overflow-hidden  ${
                box.ITEMNAME === openItemTitle
                  ? "bg-[#c8d444] "
                  : box.SECTION_NAME === fastMovingMovieItem
                  ? "bg-[#ecad47] "
                  : "bg-[#e9e294]"
              } flex-shrink-0`}
            >
              {img && (
                <img
                  alt=""
                  src={img || ""}
                  className="w-full h-full object-cover"
                  onError={() => setImg("")}
                />
              )}
            </div>
          )}

          <div className="flex-1 min-w-0 ml-1 ">
            <div className="flex justify-between items-start">
              <div className="font-medium text-gray-900  text-start flex justify-between">
                <div>{toProperCase(box.ITEMNAME)}</div>
              </div>
              <span
                className={`text-sm   ${
                  box.ITEMNAME === openItemTitle
                    ? "text-gray-800"
                    : box.SECTION_NAME === fastMovingMovieItem
                    ? "text-gray-800"
                    : "text-gray-500"
                } font-mono`}
              >
                {box.ICODE}
              </span>
            </div>

            <div className="mt-1 flex items-center ">
              <span
                className={`
              w-2 h-2 rounded-full mr-1
              ${
                box.SALE_PRICE > 0
                  ? box.BAL_STOCK > 0
                    ? "bg-green"
                    : "bg-red-400"
                  : "bg-gray-300"
              }
            `}
              />

              {box.SALE_PRICE > 0 && (
                <span className="font-medium text-gray-900">
                  {getCurrency()}
                  {FormatNumber2(box.SALE_PRICE)}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {isAddButtonType && (
        <div
          className="w-full rounded-xl overflow-hidden shadow-sm border mb-4"
          style={{ backgroundColor: "#fefefe", borderColor: "#e6e6e3" }}
        >
          {/* Product Image */}
          <div className="bg-white border-b" style={{ borderColor: "#bebaba" }}>
            {img ? (
              <img
                src={img}
                onError={() => setImg("")}
                className="w-full h-[150px] object-cover"
                alt="Product"
              />
            ) : (
              <div
                className="h-[150px] flex items-center justify-center"
                style={{ backgroundColor: "#e6e6e3", color: "#bebaba" }}
              >
                <i className="bi bi-image-fill text-[50px]"></i>
              </div>
            )}
          </div>
          <div className="p-2">
            <div
              onClick={() => {
                if (setRemarksStatus) {
                  setRemarksStatus(true);
                }
              }}
              className="font-semibold text-start text-[15px] mb-1 flex justify-between"
            >
              <div>{toProperCase(box.ITEMNAME)}</div>

              <div className="px-2 py-[2px] bg-gray-200 h-fit w-fit   rounded-md font-medium">
                Description
              </div>
            </div>

            {/* Product Details & Controls */}
            <div className="grid grid-cols-[1fr,80px] gap-2">
              <div className="grid grid-cols-2 gap-2">
                {/* Item Name */}

                {/* Info Pills with MRP and Price */}
                {box.PUR_PRICE > 0 && (
                  <div
                    className="px-2 py-[2px] rounded-md font-medium"
                    style={{ backgroundColor: "#f5874f", color: "#fff" }}
                  >
                    Pur: {getCurrency()}
                    {FormatNumber2(box.PUR_PRICE)}
                  </div>
                )}

                {box.SALE_PRICE > 0 && (
                  <div
                    className="px-2 py-[2px] rounded-md font-medium"
                    style={{ backgroundColor: "#ff4500", color: "#fff" }}
                  >
                    Sale: {getCurrency()}
                    {FormatNumber2(box.SALE_PRICE)}
                  </div>
                )}

                <div
                  className="px-2 py-[2px] rounded-md font-medium"
                  style={{ backgroundColor: "#a8cf45", color: "#0d0d0d" }}
                >
                  Stock: {box.BAL_STOCK}
                </div>

                {box.MARK_RATE > 0 && (
                  <div
                    className="px-2 py-[2px] rounded-md font-medium"
                    style={{ backgroundColor: "#007acc", color: "#fff" }}
                  >
                    MRP: {getCurrency()}
                    {FormatNumber2(box.MARK_RATE)}
                  </div>
                )}
              </div>

              <div className="flex flex-1 w-[80px]">
                {isinBillCart[0] ? (
                  <div
                    className="rounded px-2 py-1 flex items-center w-full"
                    style={{ border: "1px solid #bebaba", color: "#0d0d0d" }}
                  >
                    <button
                      onClick={() => {
                        itemClick(
                          box,
                          box,
                          setBillCartList,
                          billingDetails,
                          customerDetails,
                          -1,
                          dispatch,
                          setAlertTwoButtonModal,
                          false,
                          false,
                          prefix,
                          token,
                          false,
                          profileSetting,
                          billCartList
                        );
                        setRefreshButton((d) => !d);
                      }}
                      className="flex flex-1 justify-center"
                    >
                      <i className="bi bi-dash-lg"></i>
                    </button>
                    <div className="w-[24px] text-center text-sm font-medium">
                      {isinBillCart[0].QNTY}
                    </div>
                    <button
                      onClick={() => {
                        onClick(box);
                        setRefreshButton((d) => !d);
                      }}
                      className="flex flex-1 justify-center"
                    >
                      <i className="bi bi-plus-lg text-[16px]"></i>
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() => {
                      itemClick(
                        box,
                        box,
                        setBillCartList,
                        billingDetails,
                        customerDetails,
                        1,
                        dispatch,
                        setAlertTwoButtonModal,
                        false,
                        false,
                        prefix,
                        token,
                        false,
                        profileSetting,
                        billCartList
                      );
                      setRefreshButton((d) => !d);
                    }}
                    style={{ backgroundColor: "#a8cf45", color: "#0d0d0d" }}
                    className="py-1 px-3 rounded flex flex-1 items-center justify-center text-sm font-semibold hover:opacity-90"
                  >
                    Add +
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Add / Qty Control */}
        </div>
      )}
    </button>
  );
};

export default ItemBox;
